import config from '../../config'
import { HTTP } from  '../../http'
const pageSize = 25
const bankAccountUri = config.apiEndpoints.bankAccountUri
export default
{
    find: (customerId) =>{
        return new Promise((resolve, reject) => {
            HTTP.get(bankAccountUri.concat(customerId)).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
}